import React from 'react';
import { Widget } from '@css-xp/base';
import { PAGETITLE } from '@atlassian/temp-analytics';
import { getEntityName } from '../../recently-viewed/src/recently-viewed-utils';
import './favourite.scss';
import {
  getFavouritedBillingAccountWidgetContent,
  getFavouritedSubscriptionWidgetContent,
  getFavouritedQuoteWidgetContent,
} from './components';
import { useFavorites } from '@css-xp/base/hooks/src/use-favourites';

export const Favourites = () => {
  const { getFavourites } = useFavorites();
  const FavouritedData = getFavourites();
  const renderEmptyMessage = () => {
    return <p className="empty-favorites">You have not marked any pages as favorites yet</p>;
  };

  const renderQuoteWidget = () => {
    const quoteData = getFavourites(getEntityName(PAGETITLE.QUOTE));
    return (
      <Widget entityName={'Quotes'} hasError={quoteData.hasError} heading="Quotes" componentName="favorites">
        {getFavouritedQuoteWidgetContent(quoteData.favouritedData)}
      </Widget>
    );
  };

  const renderSubscriptionWidget = () => {
    const subscriptionData = getFavourites(getEntityName(PAGETITLE.SUBSCRIPTION));
    return (
      <Widget
        entityName={'Subscriptions'}
        hasError={subscriptionData.hasError}
        heading="Subscriptions"
        componentName="favorites"
      >
        {getFavouritedSubscriptionWidgetContent(subscriptionData.favouritedData)}
      </Widget>
    );
  };

  const renderBillingAccountWidget = () => {
    const billingAccountData = getFavourites(getEntityName(PAGETITLE.TRANSACTION_ACCOUNT));
    return (
      <Widget
        entityName={'Billing accounts'}
        hasError={billingAccountData.hasError}
        heading="Billing accounts"
        componentName="favorites"
      >
        {getFavouritedBillingAccountWidgetContent(billingAccountData.favouritedData)}
      </Widget>
    );
  };

  return (
    <div className="favorites-container">
      {FavouritedData.favouritedData.length === 0 && renderEmptyMessage()}
      {FavouritedData.favouritedData.length !== 0 && (
        <div className="favorites-content">
          <div className="favorites-widget-container">
            {<div className="favorites-widget-item">{renderQuoteWidget()}</div>}
            {<div className="favorites-widget-item">{renderSubscriptionWidget()}</div>}
            {<div className="favorites-widget-item">{renderBillingAccountWidget()}</div>}
          </div>
        </div>
      )}
    </div>
  );
};
